'use client';

import { absoluteBaseUrl } from '~/constants/environment';
import {
  useDealershipId,
  useIsDealershipPage
} from '~/context/dealership/StaticContext';
import type InventoryConditionalTile from '~/contracts/srp/InventoryConditionalTile';
import buildDealershipUrl from '~/utilities/dealership/buildDealershipUrl';
import {
  getNewCarHref,
  getNewCarVariant,
  NewCarVariant
} from '~/utilities/srp/new-car/getNewCarVariant';
import GenericNewCarTile from './GenericNewCarTile';
import MakeModelNewCarTile from './MakeModelNewCarTile';

type OwnProps = {
  position: number;
  tileMetadata: InventoryConditionalTile['tileMetadata'];
};

export default function NewCarTile({ position, tileMetadata }: OwnProps) {
  const dealershipId = useDealershipId();
  const isDealership = useIsDealershipPage();

  const relativeHref = getNewCarHref(tileMetadata);
  const href = isDealership
    ? buildDealershipUrl(`${absoluteBaseUrl}${relativeHref}`, dealershipId)
    : relativeHref;
  const variant = getNewCarVariant(tileMetadata);

  return variant === NewCarVariant.Generic ? (
    <GenericNewCarTile href={href} position={position} variant={variant} />
  ) : (
    <MakeModelNewCarTile
      href={href}
      make={tileMetadata?.make ?? ''}
      model={tileMetadata?.model}
      position={position}
      variant={variant}
    />
  );
}
